// extracted by mini-css-extract-plugin
export var avatarContainer = "_redotech-redo-web-src-arbiter-components-avatars-avatar-avatar-container";